<template>	
	<div class="map-file" style="margin-top: 20px;">
	  <!-- 数据分析管理 -->
	  <el-row :gutter="24">		  
		<el-col :span="6" class="shadow">
			
			<div class="menu-tree">
				<el-tree v-loading="treeListLoading" :data="entityTree" show-checkbox node-key="id" :default-expand-all="false"
				  draggable ref="treeX" :expand-on-click-node="false">
				  <span class="custom-tree-node" slot-scope="{ node, data }">
				    <!-- <div class="menu-item"> -->
				    <span>{{ data.cur.name }}</span>
				    <span>
				      <el-button plain type="primary" size="mini" icon="el-icon-s-data"  @click="() => handleEntityReport(node,data)" >
				        报表
				      </el-button>
				      <el-button plain type="success" size="mini" @click="() => handleEntityCar(node, data)">
				        车辆
				      </el-button>				
				    </span>
				  </span>
				</el-tree>
			</div>	
		</el-col>	
		<el-col :span="6" class="shadow">		
		  <!-- 车辆列表部分 -->
		  <div>
			  <!-- 查找参数区 -->
			  <!-- 
			  <div class="filter-container">
				  <el-input placeholder="请输入机器人ID" v-model="listQueryCar.params.id" style="width: 360px" class="filter-item"></el-input>
				  <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handleFilterCar(true)">
					搜索
				  </el-button>
			  </div>
			  -->
			  <!-- 数据列表区 -->
			  <el-table
				:data="listDataCar"
				v-loading="listLoadingCar"
				border
				highlight-current-row
				style="width: 100%;align: center;">
				<el-table-column prop="index" label="序号" width="60px" align="center">
				</el-table-column>
				<el-table-column prop="name" label="机器人名称" align="center">
				</el-table-column>
				<el-table-column prop="operator" label="操作" align="center">
				  <template v-slot:="{row,$index}">
					<el-button type="primary" size="mini"icon="el-icon-s-data"  @click="handleReport(row)"><!--@click="handleShowReportList(row)" -->
					  报表
					</el-button> 
				  </template>
				</el-table-column>
			  </el-table>
	      
			  <!-- 分页栏 -->
			  <pagination :total="totalCountsCar" :page="listQueryCar.pageIndex" layout='sizes,prev, pager, next'
				@pagination="handlePageChangeCar">
			  </pagination>
			</div>
		</el-col>
		
		<!-- 文件列表部分 -->
	    <el-col :span="12" class="shadow">
	      
			<div class="headCarName">
			  <i class="el-icon-setting"></i>&nbsp;&nbsp;运营数据&nbsp;&nbsp;&nbsp;&nbsp;<font size="2px">
			    当前机器人ID：{{curCarId }}</font>
			</div>	
			<div style="margin-top: 10px;">
				<el-date-picker
				  :clearable="false"
				  v-model="dateQuery.range"
				  type="daterange"
				  pvalue-format="yyyy-MM-dd"
				  range-separator="至"
				  start-placeholder="开始日期"
				  end-placeholder="结束日期"
				  @change="handleRangeChange">
				</el-date-picker>
				<el-button type="primary" @click="handleFilter" icon="el-icon-search" style="margin-left: 10px;margin-right: 15px">自定义查询</el-button>
			</div>
			<div style="margin-top: 10px;">	
				<el-date-picker
				    v-model="dateQuery.week"
				    type="week"
				    format="yyyy - WW 周"
				    placeholder="选择周"
				    @change="handleWeekChange">
				</el-date-picker>
				<el-button type="primary" @click="handleFilter" icon="el-icon-search" style="margin-left: 10px;margin-right: 15px">周查询</el-button>
				  
				<el-date-picker
				    v-model="dateQuery.month"
				    type="month"
				    format="yyyy - MM"
				    placeholder="选择月份"
				    @change="handleMonthChange"
					style="padding-left: 5px;">
				</el-date-picker>
				<el-button type="primary" @click="handleFilter" icon="el-icon-search" style="margin-left: 10px">月查询</el-button>
			</div>
			<div style="margin-top: 10px;">	
				<el-date-picker
				    v-model="dateQuery.year"
				    type="year"
				    format="yyyy"
				    placeholder="选择年份"
				    @change="handleYearChange">
				</el-date-picker>
				<el-button type="primary" @click="handleFilter" icon="el-icon-search" style="margin-left: 10px;margin-right: 15px">年查询</el-button>
				<!-- 
				<el-date-picker
					v-model="dateQuery.yearRange"
					type="yearrange"      
					value-format="yyyy"     
					format="yyyy"           
					start-placeholder="开始年份"
					end-placeholder="结束年份"
					range-separator="至"
					@change="handleYearRangeChange"		
					style="padding-left: 5px;">
				</el-date-picker>
				<el-button type="primary" @click="handleFilter" icon="el-icon-search" style="margin-left: 10px">年对比</el-button>
				 -->
				<el-button type="success" @click="csvExcel" icon="el-icon-download" style="margin-left: 10px">导出</el-button>
				<el-button type="warning" @click="handleReport" icon="el-icon-s-data" style="margin-left: 10px">总览</el-button>
			</div>
		  
			<el-table :data="listData" v-loading="listLoading" border highlight-current-row
				style="width: 95%; align: center;margin-top: 10px;">
				<el-table-column prop="date" label="作业日期" align="center">
				</el-table-column>
				<el-table-column prop="num" label="自动驾驶次数" align="center">
				</el-table-column>
				<el-table-column prop="duration" label="自动驾驶时长" align="center">
				</el-table-column>
				<el-table-column prop="distance" label="自动驾驶距离" align="center">
				</el-table-column>
				<el-table-column prop="area" label="自动驾驶面积" align="center">
				</el-table-column>
				<el-table-column prop="equalHands" label="工时" align="center">
				</el-table-column>			
			</el-table>
			  
			<pagination :total="totalCounts" @pagination="handlePageChange">
			</pagination>
		  
	    </el-col>
			
	  </el-row>

	<!-- 弹出框 -->
	<el-dialog title="清洁报告" :visible.sync="reportVisible" @opened="initChart" top="10vh" width="80%"> 
	  <div style="display: flex;flex-direction: column;justify-content: center;">
		<div style="align-self: center">
			<h2>{{reportTitle}}</h2>
			<div style="text-align: center;padding-top: 10px;">统计时间：{{listQuery.startTime}} - {{listQuery.endTime}}</div>
		</div>
		<div style="width: 100%; display: flex;flex-direction: row; justify-content: center;line-height: 48px;color: #000;font-size: 14px;">
			<!-- 
			<h3 style="float: right;">截止当前总等效人工：{{report.totalEqualHands}}工时</h3>
			<h3 style="float: right;padding-right: 30px;">截止当前机器人应用指数：{{report.rateHandUse}}</h3>
			 -->
			 <h3 style="font-weight: bold;margin-right: 34px;margin-top: auto;">机器人投入使用至今：</h3>
			 <h3 style="margin-right: 34px;">安全作业：<font style="font-size: 28px;"> {{report.totalWorkDays}} </font>天</h3>
			 <h3 style="margin-right: 34px;">作业时长：<font style="font-size: 28px;"> {{report.totalWorkTime}} </font>小时</h3>
			 <h3 style="margin-right: 34px;">人力当量：<font style="font-size: 28px;"> {{report.rateHandUse}} </font>人天</h3>
			 
			 <el-button type="primary" @click="downWord"  style="margin-left: 10px;">下载</el-button>
		</div>
		
		<div style="display: flex;flex-direction: column;justify-content: center; font-size: 14px;">
			
			<div  style=" width: 100%;height: 60px;display:flex;justify-content:center;flex-direction: row;color: #000;margin: 10px;">
				<div  style=" width: 15%;display:flex;justify-content:center;flex-direction: column;border:1px solid #fc6906;margin-right: 5px">
					<h3 style="text-align: center;">作业次数:<font style="font-size: 28px;">{{report.num}} </font>次</h3>
				</div>	
				<div  style=" width: 15%;display:flex;justify-content:center;flex-direction: column;border:1px solid #fc6906;margin-right: 5px">
					<h3 style="text-align: center;">作业天数:<font style="font-size: 28px;">{{report.totalDays}} </font>天</h3>
				</div>
				<div  style=" width: 15%;display:flex;justify-content:center;flex-direction: column;border:1px solid #fc6906;margin-right: 5px">
					<h3 style="text-align: center;">机器人使用率:<font style="font-size: 28px;">{{report.rateUse}} </font>%</h3>
				</div>
				<div  style=" width: 15%;display:flex;justify-content:center;flex-direction: column;border:1px solid #fc6906;margin-right: 5px">
					<h3 style="text-align: center;">作业达成率:<font style="font-size: 28px;" >{{report.rateWorkCompleted}} </font> %</h3>
				</div>
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;border:1px solid  #fc6906;margin-right: 5px">
					<h3 style="text-align: center;">首次使用:{{report.minTime}}</h3>
				</div>
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;border:1px solid #fc6906;">
					<h3 style="text-align: center;">末次使用:{{report.maxTime}} </h3>
				</div>
			</div>
			
			<div style=" width: 100%; display: flex;flex-direction: column;justify-content: center;">
				<div style="height: 30px; display: flex;flex-direction: row;justify-content: flex-start;margin: 5px 0 15px 10px;">
					<h3 style="align-self: center;">请选择图表维度</h3>
					<select v-model="chartSelected" style="height: 30px; width: 100px;align-self: center;margin-left: 10px;">
					      <option v-for="option in chartOptions" :value="option.value" :key="option.value">
					        {{ option.text }}
					      </option>
					</select>
					<el-button type="primary" @click="setSeriesChart" style="margin-left: 10px;align-self: center;line-height: 6px;">查询</el-button>
					
					<div style="display: flex;flex-direction: row;justify-content: flex-start;">
						<div class="dash-arrow"></div>
						<div style="align-self: center;margin-left: 20px;color: #ff5500;">基准线：表示清扫数据每维度的平均值</div>									
					</div>					
				</div>
				
				<div ref="chart1" style=" width: 100%;height: 600px;" ></div>
			</div>
			<!-- 			
			<div  style=" width: 100%;height: 60px;display:flex;justify-content:center;flex-direction: row;color: #000;margin: 10px;">
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;background:#fc6906;margin-right: 5px">
					<h3 style="text-align: center;">累计垃圾收集:<font style="font-size: 28px;">{{report.capacityTrash}} </font> L</h3>
				</div>	
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;background:#fc6906;margin-right: 5px">
					<h3 style="text-align: center;">倒垃圾次数:<font style="font-size: 28px;">{{report.countTrash}} </font> 次</h3>
				</div>
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;background:#fc6906;margin-right: 5px">
					<h3 style="text-align: center;">充电次数:<font style="font-size: 28px;">{{report.countCharge}} </font> 次</h3>
				</div>
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;background:#fc6906;margin-right: 5px">
					<h3 style="text-align: center;">人工辅助次数:<font style="font-size: 28px;">{{report.countAssist}} </font> 次</h3>
				</div>
				<div  style=" width: 20%;display:flex;justify-content:center;flex-direction: column;background:#fc6906;">
					<h3 style="text-align: center;">抓拍次数:<font style="font-size: 28px;">{{report.countCamera}} </font> 次</h3>
				</div>
			</div>
			 -->
			<div style=" width: 100%;height: 100px;display: flex;flex-direction: row;justify-content: space-between;color: #fff;margin: 10px;">
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content:center;background:rgba(103, 194, 58, .8);">
					<h3 style="text-align: center;">累计普扫距离</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.distance}} </font> 米</p>
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;background:rgba(64, 158, 255,.9);">
					<h3 style="text-align: center;">累计普扫面积</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.area}} </font> 平方米</p>				
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;background:rgba(230, 162, 60,.9);">
					<h3 style="text-align: center;">累计普扫时长</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.duration}} </font> h</p>				
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;background:rgba(245, 108, 108,.9);">
					<h3 style="text-align: center;">累计人力当量</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.equalHands}} </font> 人天</p>				
				</div>
			</div>
			
			<div style=" width: 100%;height: 100px;display: flex;flex-direction: row;justify-content: space-between;color: #000;margin: 10px;">
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content:center;border: 1px solid rgba(103, 194, 58, .8);">
					<h3 style="text-align: center;">日均普扫距离</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.distanceAverage}} </font> 米</p>
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;border: 1px solid rgba(64, 158, 255,.9);">
					<h3 style="text-align: center;">日均普扫面积</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.areaAverage}} </font> 平方米</p>				
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;border: 1px solid rgba(230, 162, 60,.9);">
					<h3 style="text-align: center;">日均普扫时长</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.durationAverage}} </font> h</p>				
				</div>
				<div style=" width: 24%;display:flex;flex-direction: column;justify-content: center;border: 1px solid rgba(245, 108, 108,.9);">
					<h3 style="text-align: center;">日均人力当量</h3>
					<p style="text-align: center;"><font style="font-size: 28px;">{{report.equalHandsAverage}} </font> 人天</p>				
				</div>
			</div>
		</div>
	  </div>
	</el-dialog>		
	
  </div>	
</template>

<script>
	import Pagination from '@/components/common/Pagination'
	import {getEntityTree} from '@/api/entity.js'
	import {carList} from '@/api/car'
	import {getAnalysis,reportCsv,getReport} from '@/api/report'
	import echarts from 'echarts'
	
	import ExcelJS from 'exceljs';
	import { saveAs } from 'file-saver';
	
	import JSZipUtils from 'jszip-utils'
	import Docxtemplater from 'docxtemplater';
	import PizZip from 'pizzip';
	import ImageModule from 'docxtemplater-image-module-free';
	
	export default{
		data(){
			return{				
				curEntityId:this.$store.getters['user/entityId'],
				treeListLoading:true,
				entityTree:[],
				
				loginuser:this.$store.getters['user/userName'],
				// 车辆列表部分
				listLoadingCar: false,
				listDataCar: [],
				totalCountsCar: 0,
				listQueryCar: {
				  entityId: this.$store.getters['user/entityId'],
				  pageIndex: 1,
				  pageSize: 10,
				  params: {
				    id: undefined
				  },
				  fuzzySearch: true
				},
				curCarId:undefined,
				curCarName:'',
				
				listLoading: false,
				listData: [],
				totalCounts:0,
				listQuery: {
					startTime:'',
					endTime:'',
					pageIndex: 1,
					pageSize: 10,
					dateType:0
				},
				dateQuery:{
					range:[],
					week:'',
					month:'',
					year:'',
					yearRange: [],
					weekOfYear:''
				},
				
				reportVisible:false,
				report:{},
				myChart1:null,
				// myChart2:null					
				chartSelected: 'data1',
				chartOptions: [
					{ value: 'data0', text: '--全部--' },
				    { value: 'data1', text: '清扫面积' },
				    { value: 'data2', text: '清扫距离' },
				    { value: 'data3', text: '清扫时长' },
					{ value: 'data4', text: '人力当量' }
				],
				echartImg:'',
				reportTitle:''
			}
		},
		mounted(){
			this.handleEntityInit()
		    // this.handleFilterCar()
		},
		components: {
		  Pagination
		},
		methods:{
			downWord(){
				  //这里要引入处理图片的插件，下载docxtemplater后，引入的就在其中了
				  //编写docx模板 本文后续有文档模板语法教学
				  var ImageModule = require('docxtemplater-image-module-free')
				  var fs = require('fs')
				  let _this = this
			 
				  // 读取并获得模板文件的二进制内容，放在项目根目录public中即可
				  JSZipUtils.getBinaryContent(
					'dataStatistics.docx',
					function (error, content) {
					  if (error) {
						throw error
					  }
			 
					  // 图片处理
					  let opts = {}
					  opts = { centered: false }
					  opts.getImage = chartId => {
						return _this.base64DataURLToArrayBuffer(chartId)
					  }
					  opts.getSize = function (img, tagValue, tagName) {
						//自定义指定图像大小，此处可动态调试各别图片的大小
						return [200, 60]  //例子：宽50px  高度100px
					  }
			 
					  // 创建一个PizZip实例，内容为模板的内容
					  let zip = new PizZip(content)
					  // 创建并加载docxtemplater实例对象
					  let doc = new Docxtemplater()
					  doc.attachModule(new ImageModule(opts))
					  doc.loadZip(zip)
			 
					  // 设置模板变量的值
					  doc.setData({
						carName:_this.curCarName,
						week:_this.dateQuery.weekOfYear,
						// 图片数据必须处理为模块要求的格式
						EchartImg:  _this.echartImg,						
					  })
			 
					  try {
						// 用模板变量的值替换所有模板变量
						doc.render()
					  } catch (error) {
						// 抛出异常
						let e = {
						  message: error.message,
						  name: error.name,
						  stack: error.stack,
						  properties: error.properties
						}
						console.log(JSON.stringify({ error: e }))
						throw error
					  }
			 
					  // 生成一个代表docxtemplater对象的zip文件（不是一个真实的文件，而是在内存中的表示）
					  let out = doc.getZip().generate({
						type: 'blob',
						mimeType:
						  'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
					  })
					  
					  // saveAs(out, this.curCarName+this.dateQuery.week+'清洁数据统计.docx')
					  
					  //此文件流 可以传送到后端服务器生成二进制文件（包含上传到阿里云服务器）
					 //  if (fileExport == 'export') {
						// let formData = new FormData() //创建formdata来存文件
						// const chunkfile = new File([out], '数据统计.docx')
						// formData.append('file', chunkfile) //存入文件
						// formData.append('toEmailList', _this.mailForm.toEmailList)
						// formData.append('customSubject', _this.mailForm.customSubject)
						// //formData文件  需注意此api请求方式 下文会描述
						// dataDetailsEmailApi(formData).then(res => {
						//   if (res.data.code == 200) {
						// 	_this.$message.success('发送成功')
						//   }
						// })
					 //  } else {
						//  // 将目标文件对象保存为目标类型的文件，并命名
						// saveAs(out, '数据统计.docx')
					 //  }
					}
				  )

			},
			base64DataURLToArrayBuffer(dataURL) {
			      const base64Regex = /^data:image\/(png|jpg|svg|svg\+xml);base64,/
			      if (!base64Regex.test(dataURL)) {
			        return false
			      }
			      const stringBase64 = dataURL.replace(base64Regex, '')
			      let binaryString
			      if (typeof window !== 'undefined') {
			        binaryString = window.atob(stringBase64)
			      } else {
			        binaryString = new Buffer(stringBase64, 'base64').toString('binary')
			      }
			      const len = binaryString.length
			      const bytes = new Uint8Array(len)
			      for (let i = 0; i < len; i++) {
			        const ascii = binaryString.charCodeAt(i)
			        bytes[i] = ascii
			      }
			      return bytes.buffer
			},
				
			// async downWord2(){
			// 	 // 1. 获取Word模板文件
			// 	const response = await fetch('/dataStatistics.docx'); // 模板放在public目录下
			// 	const templateArrayBuffer = await response.arrayBuffer();
				
			// 	// 2. 将ECharts图表转换为图片Base64
			// 	const chartImageData = this.convertChartToImage();
				
			// 	// 3. 准备要插入的数据
			// 	const data = {
			// 	        carName:this.curCarName,
			// 			week:this.dateQuery.week,
			// 	        // 图片数据必须处理为模块要求的格式
			// 	        EchartImg: chartImageData,
			// 	};
				
			// 	// 4. 配置图片模块
			// 	const imageOptions = {
			// 	    centered: false,
			// 	    getImage: (tagValue) => {
			// 	        // tagValue 就是上面data里的chartImage
			// 	        return Promise.resolve(tagValue);
			// 	    },
			// 	    getSize: () => {
			// 	        return [500,200]; // 设置图片在Word中的宽高 [宽， 高]
			// 	    }
			// 	};
			// 	const imageModule = new ImageModule(imageOptions);
				
			// 	// 5. 处理Zip内容并生成文档
			// 	try {
			// 	    const zip = new PizZip(templateArrayBuffer);
			// 	    const doc = new Docxtemplater(zip, {
			// 	        modules: [imageModule] // 载入图片模块
			// 	    });
				
			// 	    doc.render(data); // 注入数据
				
			// 	    // 6. 生成并下载Word文档
			// 	    const out = doc.getZip().generate({
			// 	          type: 'blob',
			// 	          mimeType: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
			// 	    });
			// 	    saveAs(out, '运行报告生成测试.docx');
			// 	} catch (error) {
			// 	    console.error('文档生成错误: ', error);
			// 	}
			// },
			// convertChartToImage() {				
			//       return this.myChart1.getDataURL({ pixelRatio: 2, backgroundColor: '#fff' }) ;
			// },
			
			// downCsv(){
			// 	// 假设您已经获取了图表的Base64数据
			// 	const base64Image = this.myChart1.getDataURL({ pixelRatio: 2, backgroundColor: '#fff' });
				
			// 	// 创建一个工作簿
			// 	const workbook = new ExcelJS.Workbook();
			// 	const worksheet = workbook.addWorksheet('Sheet1');
				
				
			// 	// 添加一些数据和样式
			// 	// worksheet.getCell('A1').value = 'Hello, ExcelJS!';
			// 	// worksheet.getCell('A1').font = { bold: true };
				
			// 	worksheet.addRow()
				
			// 	// 1. 将图片添加到工作簿
			// 	const imageId = workbook.addImage({
			// 	    base64: base64Image,
			// 	    extension: 'png',
			// 	});
				
			// 	// 2. 将图片添加到工作表的特定区域 (例如：从A1到J20的单元格区域)
			// 	worksheet.addImage(imageId, 'A1:J20');
				
			// 	// 3. 您可以继续添加表格数据等...
			// 	// worksheet.addRow(...);
				
			// 	// 4. 生成文件并触发下载
			// 	workbook.xlsx.writeBuffer().then((buffer) => {
			// 	    saveAs(new Blob([buffer]), this.curCarName+this.dateQuery.week+'清洁报告.xlsx');
			// 	});
			// },
			handleEntityInit() {
			  this.treeListLoading = true
			  getEntityTree(this.$store.getters['user/entityId']).then(res => {
			    if (res.result === "0") {
			      this.$message({
			        message: res.message,
			        type: 'success'
			      })
			    } else {
			      this.$message.error(res.message)
			    }
				//let treelst = this.treeDataTrans(res.entity)
				let entityAll = []
				entityAll.push(res.entity)
			    this.entityTree = entityAll
			    this.treeListLoading = false
			  })
			},
			treeDataTrans(item) {
			  let res = {
			    id: item.cur.id,
			    name: item.cur.name,
			    parentid: item.cur.parentId,
			    children: []
			  }
			  for (let child of item.subEntity) {
			    res.children.push(this.treeDataTrans(child))
			  }
			  return res
			},
			handleEntityReport(node,data){
				let row = data.cur
				var entityId = row.id,entityName = row.name
				
				if(this.listQuery.startTime == ''){
					this.$message.error("请选择时间");
					return;
				}		
				// console.log('dateType:'+this.listQuery.dateType)
				// getReport(this.curCarId, this.listQuery).then((res) => {
				getReport(84,entityId,null,this.listQuery).then((res) => {
				  let rs = res.result
				  if(rs == "0"){
					    this.report = res.data[0] 					  
						
						this.reportTitle = entityName+"清洁报告"
						this.reportVisible = true
				  }else{
					   this.$message.error("未查询到数据");
				  }
				});
				
			},
			handleEntityCar(node,data){
				let row = data.cur
				var entityId = row.id
				this.listQueryCar.entityId = entityId
				this.handleFilterCar()
			},
			/**
			 * 请求车辆数据
			 */
			handleFilterCar(isNewSearch = false) {
			  //如果是“新搜索”（即非翻页，而是点击搜索按钮进行搜索）
			  if(isNewSearch) {
			    //页数修改1
			    this.listQueryCar.pageIndex = 1;
			    //清空地图包列表
			    this.clearMapPackList();
			  }
			
			  this.listLoadingCar = true
			  carList(this.listQueryCar, null).then(res => {
			    let data = res.pageData
			    this.totalCountsCar = data.totalCounts
				if(data.datas!=null && data.datas.length > 0){
					// 对后端数据进行解析
					this.listDataCar = data.datas.map((item,index) => {
					  return {
					    index: index+1,
					    id: item.id,
					    name: item.name
					  }
					})
				}
			    this.listLoadingCar = false
			  })
			},
			/**
			 * 处理小车列表翻页
			 */
			handlePageChangeCar(data) {
			  this.listQueryCar.pageIndex = data.page
			  this.listQueryCar.pageSize = data.limit
			  this.handleFilterCar()
			},
			handleShowReportList(row){
				this.curCarId = row.id
				if(row.name.indexOf('S142') >= 0){
					row.name = 'RoboNeo'+row.name.substring(row.name.indexOf('_'))
				}
				this.curCarName = row.name
				// this.handleFilter()
			},
			handleFilter(){
				if(this.curCarId == '' || this.curCarId == undefined || this.curCarId == null){
					this.$message.error("请选择机器人");
					return;
				}
				this.listLoading = true;
				getAnalysis(this.curCarId, this.listQuery).then((res) => {
				   let rs = res.result
				   this.listLoading = false;
				  if(rs == "0"){
					  this.listData = res.data
					  this.totalCounts = res.count
				  }else{
					   this.$message.error("未查询到数据");
				  }
				});
			},
			handlePageChange(data){
				this.listQuery.pageIndex = data.page
				this.listQuery.pageSize = data.limit
				this.handleFilter()
			},
			csvExcel(){
				if(this.curCarId == '' || this.curCarId == undefined || this.curCarId == null){
					this.$message.error("请选择机器人");
					return;
				}
				if(this.listQuery.startTime == '' || this.listQuery.endTime == ''){
					this.$message.error("请选择时间");
					return;
				}
				reportCsv(this.curCarId, this.listQuery.startTime, this.listQuery.endTime)
				    .then(res => {
				        // 创建一个 Blob 对象
				        const blob = new Blob([res], {
				            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
				        });
				
				        // 创建一个链接元素
				        const a = document.createElement('a');
				        a.href = window.URL.createObjectURL(blob);
				        a.download = this.curCarId+'.xlsx'; // 设置文件名
				        document.body.appendChild(a);
				        a.click();
				        document.body.removeChild(a);
				        window.URL.revokeObjectURL(a.href);
				    })
				    .catch(error => {
				        console.error('导出失败:', error);
				        alert('导出失败，请稍后重试！');
				    });
			},
			handleReport(row){
				
				// if(this.curCarId == '' || this.curCarId == undefined || this.curCarId == null){
				// 	this.$message.error("请选择机器人");
				// 	return;
				// }
				if(this.listQuery.startTime == ''){
					this.$message.error("请选择时间");
					return;
				}
				this.curCarId = row.id
				// console.log('dateType:'+this.listQuery.dateType)
				// getReport(this.curCarId, this.listQuery).then((res) => {
				getReport(85,null,this.curCarId,this.listQuery).then((res) => {
				   let rs = res.result
				  if(rs == "0"){
					    this.report = res.data[0] 		
						this.reportTitle = this.curCarName+"机器人清洁报告"
						this.reportVisible = true
				  }else{
					   this.$message.error("未查询到数据");
				  }
				});
			},
			initChart() {
				if(this.myChart1 == null){
					this.myChart1 = echarts.init(this.$refs.chart1)
					this.myChart1.setOption(option)
					window.onresize = this.myChart1.resize
				}
				
				let rList = this.report.rList , rLastList =  this.report.rLastList

				let xDate			
				if(this.listQuery.dateType == 2){
					xDate = this.getMonthEvryDay(this.listQuery.startTime)
				}else if(this.listQuery.dateType == 3){
					xDate = ['01','02','03','04','05','06','07','08','09','10','11','12']
				}else if(this.listQuery.dateType == 4){
					xDate = this.getYearRange(this.listQuery.startTime,this.listQuery.endTime)
				}else{
					xDate = this.getDateRange(this.listQuery.startTime,this.listQuery.endTime)
				}
				
				yData1 = new Array(xDate.length).fill(''),yData2 = new Array(xDate.length).fill(''),yData3 = new Array(xDate.length).fill(''),yData4 = new Array(xDate.length).fill(''),
				tData1 = new Array(xDate.length).fill(''),tData2 = new Array(xDate.length).fill(''),tData3 = new Array(xDate.length).fill(''),tData4 = new Array(xDate.length).fill(''),
				hData1 = new Array(xDate.length).fill(''),hData2 = new Array(xDate.length).fill(''),hData3 = new Array(xDate.length).fill(''),hData4 = new Array(xDate.length).fill('')				
				
				//let tRate=[], hRate=[]
				
				if(rList != null && rList.length > 0){
					
					for(var j = 0 ; j < rList.length-1 ; j ++){
						let previous = rList[j] ,cur = rList[j+1]
						var r1 = previous.area == 0 ? 100 : ((cur.area - previous.area)/previous.area * 100).toFixed(2),
							r2 = previous.distance == 0 ? 100 : ((cur.distance - previous.distance)/previous.distance * 100).toFixed(2),
							r3 = previous.duration == 0 ? 100 : ((cur.duration - previous.duration)/previous.duration * 100).toFixed(2),
							r4 = previous.equalHands == 0 ? 100 : ((cur.equalHands - previous.equalHands)/previous.equalHands * 100).toFixed(2)
						// let rate = {
						// 	'xDate':cur.xDate,
						// 	'tArea':r1,
						// 	'tDistance':r2,
						// 	'tDuration':r3,
						// 	'tEqualHands':r4
						// }	
						// tRate.push(rate)	
						
						let rate = {
							'xDate':cur.xDate,
							'hArea':r1,
							'hDistance':r2,
							'hDuration':r3,
							'hEqualHands':r4
						}	
						hRate.push(rate)						
					}
					
					if(rLastList != null && rLastList.length > 0){					
						rList.map((cur,index)=>{
							rLastList.map((last,index2)=>{
								if(cur.xDate == last.xDate){
									var r1 = last.area == 0 ? 100 : ((cur.area - last.area)/last.area * 100).toFixed(2),
										r2 = last.distance == 0 ? 100 : ((cur.distance - last.distance)/last.distance * 100).toFixed(2),
										r3 = last.duration == 0 ? 100 : ((cur.duration - last.duration)/last.duration * 100).toFixed(2),
										r4 = last.equalHands == 0 ? 100 : ((cur.equalHands - last.equalHands)/last.equalHands * 100).toFixed(2)
									// let rate = {
									// 	'xDate':cur.xDate,
									// 	'hArea':r1,
									// 	'hDistance':r2,
									// 	'hDuration':r3,
									// 	'hEqualHands':r4
									// }	
									// hRate.push(rate)	
									
									let rate = {
										'xDate':cur.xDate,
										'tArea':r1,
										'tDistance':r2,
										'tDuration':r3,
										'tEqualHands':r4
									}	
									tRate.push(rate)	
									
									return
								}
							})
						})
					}
					
					for(var i = 0 ; i < xDate.length; i++){
						rList.forEach((item,index)=>{
							if(xDate[i] == item.xDate){
								yData1[i] = (item.area / 10000).toFixed(2)
								yData2[i] = (item.distance / 1000 ).toFixed(2)
								yData3[i] = item.duration
								yData4[i] = (item.equalHands / 2).toFixed(2)
								
								hData1[i] = 100
								hData2[i] = 100 
								hData3[i] = 100
								hData4[i] = 100
								return
							}
						})
						if(tRate.length > 0){
							tRate.forEach((item,index)=>{
								if(xDate[i] == item.xDate){
									tData1[i] = item.tArea 
									tData2[i] = item.tDistance 
									tData3[i] = item.tDuration
									tData4[i] = item.tEqualHands
									return
								}
							})
						}
						if(hRate.length > 0){
							hRate.forEach((item,index)=>{
								if(xDate[i] == item.xDate){
									hData1[i] = item.hArea 
									hData2[i] = item.hDistance 
									hData3[i] = item.hDuration
									hData4[i] = item.hEqualHands
									return
								}
							})
						}								
						///
					}					
					///
				}							
						
				let seriesData = {
					xAxis: [
					  {
					    data: xDate
					  }
					],
					series: [	
						{
							name: legends[0],
							data: yData1,
							markLine: {
							        data: [
							            {type: 'average', name: '平均值'},
							            //{yAxis: 'max'} // 在Y轴最大值处画一条线
							        ],
							        lineStyle: { // 设置线条样式
							            color: '#ff5500', // 设置线条颜色为红色
							            type: 'dashed', // 设置线条类型为虚线
							            width: 2 // 设置线条宽度
							        },
							        label: {
							            show: true, // 显示标签
							            position: 'end' // 标签的位置
							        }
							}
						},
						{
							name: legends[1],
							data: yData2,
							markLine: {
							        data: [
							            {type: 'average', name: '平均值'},
							            //{yAxis: 'max'} // 在Y轴最大值处画一条线
							        ],
							        lineStyle: { // 设置线条样式
							            color: '#ff5500', // 设置线条颜色为红色
							            type: 'dashed', // 设置线条类型为虚线
							            width: 2 // 设置线条宽度
							        },
							        label: {
							            show: true, // 显示标签
							            position: 'end' // 标签的位置
							        }
							}
						},
						{
							name: legends[2],
							data: yData3,
							markLine: {
							        data: [
							            {type: 'average', name: '平均值'},
							            //{yAxis: 'max'} // 在Y轴最大值处画一条线
							        ],
							        lineStyle: { // 设置线条样式
							            color: '#ff5500', // 设置线条颜色为红色
							            type: 'dashed', // 设置线条类型为虚线
							            width: 2 // 设置线条宽度
							        },
							        label: {
							            show: true, // 显示标签
							            position: 'end' // 标签的位置
							        }
							}
						},
						{
							name: legends[3],
							data: yData4,
							markLine: {
							        data: [
							            {type: 'average', name: '平均值'},
							            //{yAxis: 'max'} // 在Y轴最大值处画一条线
							        ],
							        lineStyle: { // 设置线条样式
							            color: '#ff5500', // 设置线条颜色为红色
							            type: 'dashed', // 设置线条类型为虚线
							            width: 2 // 设置线条宽度
							        },
							        label: {
							            show: true, // 显示标签
							            position: 'end' // 标签的位置
							        }
							}
						},
						
						{
							name: legends[4],
							data: tData1,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = tData1[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[5],
							data: tData2,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = tData2[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[6],
							data: tData3,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = tData3[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[7],
							data: tData4,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = tData4[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						
						{
							name: legends[8],
							data: hData1,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = hData1[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[9],
							data:hData2,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = hData2[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[10],
							data: hData3,
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = hData3[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						},
						{
							name: legends[11],
							data: hData4,						
							label: {
								show: true,
								position: 'top',
								rotate:360,
								offset: [ 0, 25 ], // 固定向上偏移25像素
								formatter: function(params) {		
									var idx = params.dataIndex;
									var percent = hData4[idx];
									var arrow = percent >= 0 ? '▲' : '▼';
									var color = percent >= 0 ? 'red' : 'blue';
									return `{${color}|${arrow}${Math.abs(percent)}%}`;
								},
								rich: {
									red: { color: '#ff0000' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] },
									blue: { color: '#0000ff' ,fontSize: 12, align: 'center', padding: [25, 0, 0, 0] }
								}
							}
						}
					]				
				};
				this.myChart1.setOption(seriesData)			
				this.setSeriesChart()
			},
			setSeriesChart(){
								
				let legSelected = {
						'清扫面积':true,'清扫面积同比增长':true,'清扫面积环比增长':true,
						'清扫距离':true,'清扫距离同比增长':true,'清扫距离环比增长':true,
						'清扫时长':true,'清扫时长同比增长':true,'清扫时长环比增长':true,
						'人力当量':true,'人力当量同比增长':true,'人力当量环比增长':true
					}
				
				if(this.chartSelected == 'data1'){ // 0-4-8			
					legSelected = {
						'清扫面积':true,'清扫面积同比增长':true,'清扫面积环比增长':true,
						'清扫距离':false,'清扫距离同比增长':false,'清扫距离环比增长':false,
						'清扫时长':false,'清扫时长同比增长':false,'清扫时长环比增长':false,
						'人力当量':false,'人力当量同比增长':false,'人力当量环比增长':false
					}
				}else if(this.chartSelected == 'data2'){ // 1-5-9
					legSelected = {
						'清扫面积':false,'清扫面积同比增长':false,'清扫面积环比增长':false,
						'清扫距离':true,'清扫距离同比增长':true,'清扫距离环比增长':true,
						'清扫时长':false,'清扫时长同比增长':false,'清扫时长环比增长':false,
						'人力当量':false,'人力当量同比增长':false,'人力当量环比增长':false
					}
				}else if(this.chartSelected == 'data3'){ // 2-6-10					
					legSelected = {
						'清扫面积':false,'清扫面积同比增长':false,'清扫面积环比增长':false,
						'清扫距离':false,'清扫距离同比增长':false,'清扫距离环比增长':false,
						'清扫时长':true,'清扫时长同比增长':true,'清扫时长环比增长':true,
						'人力当量':false,'人力当量同比增长':false,'人力当量环比增长':false
					}
				}else if(this.chartSelected == 'data4'){ // 3-7-11
					legSelected = {
						'清扫面积':false,'清扫面积同比增长':false,'清扫面积环比增长':false,
						'清扫距离':false,'清扫距离同比增长':false,'清扫距离环比增长':false,
						'清扫时长':false,'清扫时长同比增长':false,'清扫时长环比增长':false,
						'人力当量':true,'人力当量同比增长':true,'人力当量环比增长':true
					}
				}
				let seriesOption = {
					 legend: {
					    selected: legSelected
					  }
				}
				this.myChart1.setOption(seriesOption)	//, { notMerge: false }
				
				this.echartImg = this.myChart1.getDataURL({
					pixelRatio: 2, // 导出的图片分辨率比例，默认为 1。
					backgroundColor: '#fff' // 导出的图片背景色，默认使用 option 里的 backgroundColor
				  })
			},
			handleRangeChange(value){
				if(value){
					 // console.log(value)
					 let start = value[0]
					 let end = value[1]
					 
					 this.dateQuery.week = ''
					 this.dateQuery.month = ''
					 this.dateQuery.year = ''
					 this.dateQuery.yearRange = []
					 
					 this.listQuery.dateType = 0
					 this.listQuery.startTime = this.formatDate(start)
					 this.listQuery.endTime = this.formatDate(end)
				}
			},
			handleWeekChange(value) {
			      if (value) {
			        // console.log(value)
			        
			        const selectedDate = new Date(value)
					 // 计算周日的日期（开始日期）
					const weekStart = new Date(selectedDate);
					weekStart.setDate(selectedDate.getDate() - selectedDate.getDay());					
					 // 计算周六的日期（结束日期）
					const weekEnd = new Date(weekStart);
					weekEnd.setDate(weekStart.getDate() + 6);
					
					
					// 获取周的第一天（周一）
              //       const weekStart = new Date(value)
			  //       const dayOfWeek = weekStart.getDay() // 周日是0，周一是1，...
			  //       // 如果周的第一天不是周一，则回退到上一周的周一
			  //       if (dayOfWeek !== 1) {
			  //         weekStart.setDate(weekStart.getDate() - dayOfWeek+1)
			  //       }
			  //       // 计算周的最后一天（周日）
			  //       const weekEnd = new Date(weekStart)
			  //       weekEnd.setDate(weekEnd.getDate() + 6)				
					
					this.dateQuery.range = []
					this.dateQuery.month = ''
					this.dateQuery.year = ''
					this.dateQuery.yearRange = []
					this.dateQuery.weekOfYear = this.getYearWeek(selectedDate)
			 
			        // 存储周的开始和结束日期
					this.listQuery.dateType = 1
			        this.listQuery.startTime = this.formatDate(weekStart)
			        this.listQuery.endTime = this.formatDate(weekEnd)
			      }
			    },
			    // 月选择器获取月份日期范围
			    handleMonthChange(value) {
			      // 确保value是一个有效的Date对象
			      if (value) {
			        // 获取月份的第一天
			        const firstDay = new Date(value.getFullYear(), value.getMonth(), 1)			 
			        // 获取下一个月的第一天
			        const nextMonthFirstDay = new Date(value.getFullYear(), value.getMonth() + 1, 1)		 
			        // 获取当前月份的最后一天（即下一个月第一天的前一天）
			        const lastDay = new Date(nextMonthFirstDay - 86400000) // 一天有86400000毫秒
			 
					this.dateQuery.week = ''
					this.dateQuery.range = []
					this.dateQuery.year = ''
					this.dateQuery.yearRange = []
			 
			        // 更新组件数据
					this.listQuery.dateType = 2
			        this.listQuery.startTime = this.formatDate(firstDay)
			        this.listQuery.endTime =  this.formatDate(lastDay)
			      }
			    },
				handleYearChange(value){
					if(value){
						// 获取月份的第一天
						const firstDay = new Date(value.getFullYear(), value.getMonth(), 1)								

						// 创建一个新的Date对象，设置为指定年份的12月31日
						const lastDay = new Date(value.getFullYear(), 11, 31);					    
						// 获取并返回年份、月份和日期部分
						const lastDayString = `${lastDay.getFullYear()}-${String(lastDay.getMonth() + 1).padStart(2, '0')}-${String(lastDay.getDate()).padStart(2, '0')}`;
						    	
							
						this.dateQuery.week = ''
						this.dateQuery.range = []					
						this.dateQuery.month = ''
						this.dateQuery.yearRange = []
									 
						// 更新组件数据
						this.listQuery.dateType = 3
						this.listQuery.startTime = this.formatDate(firstDay)
						this.listQuery.endTime = lastDayString
						
					}
				},
				handleYearRangeChange(value){
					if (value && value.length === 2) {
					    const [start, end] = [
					        parseInt(value[0]),  // 转换为数字
					        parseInt(value[1])
					    ];
						
						this.dateQuery.week = ''
						this.dateQuery.range = []					
						this.dateQuery.month = ''
						this.dateQuery.year = ''
						
						this.listQuery.dateType = 4
						this.listQuery.startTime = start
						this.listQuery.endTime = end
						
					    // console.log("选择范围:", start, "~", end);
					}
				},
				formatDate(date) {
				      const year = date.getFullYear()
				      const month = (date.getMonth() + 1).toString().padStart(2, '0') // 填充前导零
				      const day = date.getDate().toString().padStart(2, '0') // 填充前导零
				      return `${year}-${month}-${day}`
				},
				getYearRange(start,end){
					const years = [];
					if (start > end) [start, end] = [end, start];
					let cur = start
					while(cur <= end){						
						years.push(cur)
						cur += 1
					}
					return years
				},
				getDateRange(startDate, endDate) {
				  const dates = [];
				  // 确保 startDate <= endDate
				  const start = new Date(startDate);
				  const end = new Date(endDate);
				  if (start > end) [start, end] = [end, start]; // 交换顺序
				
				  // 逐天递增，直到覆盖结束日期
				  let currentDate = new Date(start);
				  while (currentDate <= end) {
					  let current = this.formatDate(new Date(currentDate))
					  dates.push(current.substr(current.indexOf('-') + 1)); // 保存日期对象
					  currentDate.setDate(currentDate.getDate() + 1); // 增加一天
				  }
				
				  return dates;
				},
				 //获取一个月的天数
				getCountDays(ym) {
					  var curDate = new Date(ym);					  
					  /* 获取当前月份 */
					  var curMonth = curDate.getMonth();
					  /*  生成实际的月份: 由于curMonth会比实际月份小1, 故需加1 */
					  curDate.setMonth(curMonth + 1);
					  /* 将日期设置为0, 这里为什么要这样设置, 我不知道原因, 这是从网上学来的 */
					  curDate.setDate(0);
					  /* 返回当月的天数 */
					  return curDate.getDate();
				 },
				//获取一个月日期		
				getMonthEvryDay(ym){	
					var month,day 
					var yms = ym.split('-')
					month = new Date().getMonth() + 1;	 
				
					if(yms[1] == month){
						day = new Date().getDate();
					}else{
						month = new Date(ym).getMonth() + 1;	
						day = this.getCountDays(ym);
					}		   
					
					if(month < 10 ){
						month = '0'+month
					}		   
					var dayArry=[];
					for (var k = 1; k <= day; k++) {
						 let d = k
						 if(d < 10){
							 d = '0'+d
						 }
						 dayArry.push(month+"-"+d);
					}
					return dayArry;
				},
				//计算本年的周数
				getYearWeek(endDate) {
					//本年的第一天
					var beginDate = new Date(endDate.getFullYear(), 0, 1);
					//星期从0-6,0代表星期天，6代表星期六
					var endWeek = endDate.getDay();
					if (endWeek == 0) endWeek = 7;
					var beginWeek = beginDate.getDay();
					if (beginWeek == 0) beginWeek = 7;
					//计算两个日期的天数差
					var millisDiff = endDate.getTime() - beginDate.getTime();
					var dayDiff = Math.floor(( millisDiff + (beginWeek - endWeek) * (24 * 60 * 60 * 1000)) / 86400000);
					return Math.ceil(dayDiff / 7) + 1;
				} 
		////	
		}
	}
	
	
	const legends = ['清扫面积', '清扫距离', '清扫时长', '人力当量','清扫面积同比增长', '清扫距离同比增长', '清扫时长同比增长', '人力当量同比增长','清扫面积环比增长', '清扫距离环比增长', '清扫时长环比增长', '人力当量环比增长']
	const colors = ['#5470c6','#91cc75','#e8b952','#ee6666']
	const colors2 = ['#6b90fd','#b4fc90','#ffcb5a','#fd6c6c']
	const units = ['公顷','千米', '小时', '人天','%','%','%','%','%','%','%','%']

	let yData1 = new Array(5).fill('0'),yData2 = new Array(5).fill('0'),yData3 = new Array(5).fill('0'),yData4 = new Array(5).fill('0'),
		tData1 = new Array(5).fill('0'),tData2 = new Array(5).fill('0'),tData3 = new Array(5).fill('0'),tData4 = new Array(5).fill('0'),
		hData1 = new Array(5).fill('0'),hData2 = new Array(5).fill('0'),hData3 = new Array(5).fill('0'),hData4 = new Array(5).fill('0')
	let tRate=[],hRate=[]
	
	const labelOption = {
	  show: true,
	  rotate: -90,
	  // formatter: '{c}  {name|{a}}',
	  formatter:function (params){
		  var idx = params.dataIndex,data = params.data,name = params.seriesName
		  const unit = units[idx]	
		  return `${data}`
	  },
	  // fontSize: 12,
	  textStyle: { // 字体样式
			color: '#fff', // 标签字体颜色
	        fontSize: 14, // 标签字体大小
	  },
	  rich: {
	    name: {}
	  }
	}
	
	let option = {
	  tooltip: {
	    trigger: 'axis', //'item' | 'axis'
	    axisPointer: {
	      type: 'shadow'
	    },
		 formatter: function (params) {
			let res = '', axis = ''
			params.forEach(function (item) {
				axis = item.axisValue
				var data = item.data,name = item.seriesName,seriesIdx = item.seriesIndex
				const unit = units[seriesIdx]	
			    res += `${name}:${data}${unit}<br/>`
			});	    
		    return `${axis} <br/> ${res}` 
		}
	  },
	  legend: {
	    data: legends
	  },
	  toolbox: {
	    show: true,
	    orient: 'vertical',
	    left: 'right',
	    top: 'center',
	    feature: {
	      mark: { show: true },
	      dataView: { show: true, readOnly: false },
	      magicType: { show: true, type: ['line', 'bar', 'stack'] },
	      restore: { show: true },
	      // saveAsImage: { show: true }
		  saveAsImage: {
		    type: 'png',
		    title: '保存图片',
		    pixelRatio: 2 // 可提高导出图片清晰度
		   }
	    }
	  },
	  xAxis: [
	    {
	      type: 'category',
	      axisTick: { show: false },
		  axisLabel: {
		    show: true,
		    fontSize: 14, // 设置x轴标签的字体大小
			fontWeight: 'bold' 
		  },
		  nameTextStyle:{
			  fontSize: 14 ,
			  fontWeight: 'bold' 
		  },
	      data: ['2012', '2013', '2014', '2015', '2016']
	    }
	  ],
	  yAxis: [
	    {
	      name: '清扫数据',
	      type: 'value',
	      position: 'left',
	      alignTicks: true,
	      axisLine: {
	        show: true,
	        lineStyle: {
	          color: '#91CC75'
	        }
	      },
		  axisLabel: {
		    show: true,
		    fontSize: 14 ,// 设置x轴标签的字体大小
			fontWeight: 'bold' 
		  },
		  nameTextStyle:{
		  		fontSize: 14 ,
				fontWeight: 'bold' 
		  }
	    },
		{
		  name: '人力当量',
		  type: 'value',
		  position: 'left',
		  alignTicks: true,
		  offset:60,
		  axisLine: {
		    show: true,
		    lineStyle: {
		      color: '#37afff'
		    }
		  },
		  axisLabel: {
		    show: true,
		    fontSize: 14, // 设置x轴标签的字体大小
			fontWeight: 'bold' 
		  },
		  nameTextStyle:{
		  		fontSize: 14 ,
				fontWeight: 'bold' 
		  }
		},
	    {
	      name: '增长率%',
	      type: 'value',
	      position: 'right',
	      alignTicks: true,
	      axisLine: {
	        show: true,
	        lineStyle: {
	          color: '#fd8eac'
	        }
	      },
	      axisLabel: {
	        formatter: '{value} %',
			fontSize: 14 ,
			fontWeight: 'bold' 
	      },
		  nameTextStyle:{
		  		fontSize: 14 ,
				fontWeight: 'bold' 
		  }
	    }
	  ],
	  series: [
	    {
	      name: legends[0],
	      type: 'bar',
	      barGap: 0,
	      label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
			  color:colors2[0]
		  },
		  yAxisIndex:0,
	      data: yData1 //[320, 332, 301, 334, 390]
	    },
	    {
	      name: legends[1],
	      type: 'bar',
	      label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
		  	color:colors2[1]
		  },
		  yAxisIndex:0,
	      data:  yData2 //[220, 182, 191, 234, 290]
	    },
	    {
	      name: legends[2],
	      type: 'bar',
	      label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
		  	color:colors2[2]
		  },
		  yAxisIndex:0,
	      data:  yData3 //[150, 232, 201, 154, 190]
	    },
	    {
	      name: legends[3],
	      type: 'bar',
	      label: labelOption,
	      emphasis: {
	        focus: 'series'
	      },
		  itemStyle:{
				color:colors2[3]
		  },
		  yAxisIndex:1,
	      data:  yData4 // [98, 77, 101, 99, 40]
	    },
	    {
	      name: legends[4],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
			width:5,
		  	color:colors[0]
		  },
		  itemStyle: {
		    color:colors[0] // 图例颜色与线体颜色一致
		  },
	      data:  tData1, // [23, 33.09, 23.50, 41.04, 41.08]
		  label: {
		  		show: true,
		  		position: 'top',
		  		rotate:360,
		  		offset: [ 0, 25 ], // 固定向上偏移25像素
		  		formatter: function(params) {		
		  			var idx = params.dataIndex;
		  			var percent = tData1[idx];
		  			var arrow = percent >= 0 ? '▲' : '▼';
		  			var color = percent >= 0 ? 'red' : 'blue';
		  			return `{${color}|${arrow}${Math.abs(percent)}%}`;
		  		},
		  		rich: {
		  			red: { color: '#ff0000' ,fontSize: 16, align: 'center', padding: [25, 0, 0, 0] },
		  			blue: { color: '#0000ff' ,fontSize: 16, align: 'center', padding: [25, 0, 0, 0] }
		  		}
		   }
	    },
	    {
	      name: legends[5],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[1]
		  },
		  itemStyle: {
		    color:colors[1] // 图例颜色与线体颜色一致
		  },
	      data: tData1 //[33, 43.09, 53.50, 61.04, 61.08],	      
	    },
	    {
	      name: legends[6],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[2]
		  },
		  itemStyle: {
		    color:colors[2] // 图例颜色与线体颜色一致
		  },
	       data: tData2 // [13, 23.09, 33.50, 42.04, 45.08]
	    },
	    {
	      name: legends[7],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[3]
		  },
		  itemStyle: {
		    color:colors[3] // 图例颜色与线体颜色一致
		  },
	       data: tData3 // [23.5, 32.09, 33.50, 44.04, 45.08]
	    },
	    {
	      name: legends[8],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[0]
		  },
		  itemStyle: {
		    color:colors[0] // 图例颜色与线体颜色一致
		  },
	      data: tData4 // [83, 83.09, 93.50, 100, 100]
	    },
	    {
	      name: legends[9],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[1]
		  },
		  itemStyle: {
		    color:colors[1] // 图例颜色与线体颜色一致
		  },
	       data: hData1 // [63, 73.09, 83.50, 91.04, 100]
		},   
	    {
	      name: legends[10],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[2]
		  },
		  itemStyle: {
		    color:colors[2] // 图例颜色与线体颜色一致
		  },
	      data: hData2 // [53, 63.09, 63.50, 72.04, 95.08]
	    },
	    {
	      name: legends[11],
	      type: 'line',
	      yAxisIndex:2,
	      emphasis: {
	        focus: 'series'
	      },
		  lineStyle: {
		  	width:5,
		  	color:colors[3]
		  },
		  itemStyle: {
		    color:colors[3] // 图例颜色与线体颜色一致
		  },
	       data: hData3 // [100, 100, 100, 100, 100]
	    }
	  ]
	};
	
	let option1 = {
		  tooltip: {
			trigger: 'axis',
			axisPointer: {
			  type: 'cross',
			  crossStyle: {
				color: '#ff5500'
			  }
			}
		  },
		  toolbox: {
			feature: {
			  dataView: { show: true, readOnly: false },
			  magicType: { show: true, type: ['bar'] },
			  restore: { show: true },
			  saveAsImage: { show: true }
			}
		  },
		 //  legend: {
			// data: ['同比增长', '环比增长']
		 //  },
		  xAxis: [
			{
			  type: 'category',
			  data: ['清扫时长/小时', '清扫面积/公顷', '清扫距离/千米', '人力当量/人天', '任务次数/次'],
			  axisPointer: {
				type: 'shadow'
			  }
			}
		  ],
		  yAxis: {
			  type: 'value',
			  name: '数据同环比增长率',
			  axisLabel: {
				formatter: '{value}'
			  }
		  },
		  series: [
			{
			  name: '同比增长',
			  type: 'bar',
			  tooltip: {
				valueFormatter: function (value) {
				  return value + '';
				}
			  },
			  itemStyle: { color: '#2f8aff' },
			  data: [2.0, 4.9, 7.0, 23.2, 25.6]
			},
			{
			  name: '',
			  type: 'bar',
			  itemStyle: {
					color: 'transparent',      // 透明填充
					borderColor: 'transparent' // 透明边框
			   },
			  barWidth: 0,                 // 可选：宽度设为0彻底隐藏
			  label: { show: false },      // 关闭标签
			  tooltip: { show: false },    // 关闭提示框  
			  emphasis: {                  // 禁用悬停效果
			    itemStyle: {
					color: 'transparent',
			        borderColor: 'transparent'
			    }
			 }	
			},
			{
			  name: '环比增长',
			  type: 'bar',
			  tooltip: {
				valueFormatter: function (value) {
				  return value + ' ';
				}
			  },
			  itemStyle: { color: '#00aa00' },
			  data: [2.6, 5.9, 9.0, 26.4, 28.7 ]
			}
		  ]
	};
	
</script>
<style>
	.el-tree-node__content {
	  /* background: #F5F8FA; */
	  height: 50px;
	}
	.custom-tree-node {
	  flex: 1;
	  display: flex;
	  align-items: center;
	  justify-content: space-between;
	  font-size: 14px;
	  padding-right: 8px;
	  box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
	  height: 40px;
	  padding-left: 10px;
	}
</style>
<style scoped lang="scss">
	.dash-arrow {
	    position: relative;
	    width: 100px; /* 虚线总长度 */
	    // height: 4px;  /* 线条高度 */
	    // margin: 50px auto;
		 margin-left: 20px;
	}
	
	.dash-arrow::before {
	    content: "";
	    position: absolute;
	    left: 0;
	    top: 50%;
	    width: 100%;
	    height: 4px;
	    background: 
	        linear-gradient(to right, 
	            red 0%, #ff5500 4px,  /* 红色线段 */
	            transparent 4px, transparent 8px /* 透明间隔 */
	        );
	    background-size: 8px 4px; /* 控制虚线间距 */
	    transform: translateY(-50%);
	}
	
	.dash-arrow::after {
	    content: "";
	    position: absolute;
	    right: -20px; /* 调整箭头位置 */
	    top: 50%;
	    width: 0; 
	    height: 0; 
	    border-top: 6px solid transparent;
	    border-bottom: 6px solid transparent;
	    border-left: 18px solid #ff5500; /* 箭头颜色 */
	    transform: translateY(-50%);
	}
	
	// .arrow {
	//   position: relative;
	//   display: inline-block;
	//   padding-right: 20px; /* 根据需要调整，以确保有足够的空间显示箭头 */
	// }
	 
	// .arrow::after {
	//   content: "";
	//   position: absolute;
	//   right: 0;
	//   top: 50%;
	//   transform: translateY(-50%);
	//   width: 0;
	//   height: 0;
	//   border-style: solid;
	//   border-width: 5px 0 5px 10px; /* 控制箭头的宽度和高度 */
	//   border-color: transparent transparent transparent black; /* 控制箭头的颜色 */
	// }
	 
	// .arrow::before {
	//   content: "";
	//   position: absolute;
	//   right: 10px; /* 根据需要调整，以确保箭头与文本有一定距离 */
	//   top: 0;
	//   bottom: 0;
	//   border-right: 2px dashed black; /* 控制虚线的样式 */
	// }
	
	.el-year-table::v-deep {
	  td {
	    padding: 8px 0;
	
	    div {
	      height: 48px;
	      padding: 6px 0;
	      box-sizing: border-box;
	      .cell {
	        height: 36px;
	        line-height: 36px;
	        border-radius: 18px;
	      }
	    }
	
	    &.start-date div {
	      border-top-left-radius: 24px;
	      border-bottom-left-radius: 24px;
	    }
	
	    &.end-date div {
	      border-top-right-radius: 24px;
	      border-bottom-right-radius: 24px;
	    }
	
	    &.in-range div {
	      background-color: #f2f6fc;
	    }
	
	    &.start-date, &.end-date {
	      .cell {
	        color: #fff;
	        background-color: #409eff;
	      }
	    }
	
	    &.today.start-date, &.today.end-date {
	      .cell {
	        color: #fff;
	      }
	    }
	  }
	}
</style>
